import queryString from 'query-string';

import { apiFetch } from './utils/api';

// const mockedFilterValues = require('./mocks/v2/qlik/filtervalues.json');

export const filterValues = {
  /**
   * @desc Filter values fetch
   *
   * @param {(string)} ssids - Ssid of the user we're trying to fetch the data for. Comma seperated if multiple
   * supported.
   *
   * @return json - data or error message
   */
  get: async (args) => {
    // return mockedFilterValues;
    const options = {
      method: 'GET',
    };
    const query = queryString.stringify(args, { arrayFormat: 'comma' });
    const url = `/v2/qlik/filtervalues?${query}`;

    const { body } = await apiFetch(url, {
      ...options,
    });

    return body;
  },
};
